import React, { useState, useEffect } from "react";
import TabList from "../../Components/TabList";
import { Grid, Box, Container, Typography } from "@mui/material";

//Components
import IndexHeader from "../../Components/IndexHeader";
import Footer from "../../Components/Footer";

const PrivacyPolicy = () => {
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);
  return (
    <>
      <IndexHeader />
      <Typography style={{display: 'flex', justifyContent: 'center', marginTop:'70px'}} variant="h4" component="h2">
        <strong>Privacy Policy</strong>
      </Typography>

      <Grid container>
        <Container maxWidth="lg" className="header-container-1">

          <Grid className="privacy-content" item xs={12} style={{ marginTop: "100px", marginBottom:"100px", }}>
            <h5 style={{marginBottom:'20px'}}>Last updated: April 5, 2023</h5>
            <p>We are committed to protecting your privacy and ensuring the security of your personal 
              information. This Privacy Policy outlines the types of information we collect from you, 
              how we use it, and how we protect it.</p>
              <p>We reserve the right to make changes to this Privacy Policy at any time and for any reason. We will 
            alert you about any changes by updating the 'Last updated' date of this Privacy Policy. You are 
            encouraged to periodically review this Privacy Policy to stay informed of updates. You will be 
            deemed to have been made aware of, will be subject to, and will be deemed to have accepted the 
            changes in any revised Privacy Policy by your continued use of the App after the date such revised 
            Privacy Policy is posted.</p>
            <p>This Privacy Policy has been compiled to better serve those who are concerned with how their 'Personally 
            Identifiable Information' (PII) is being used online. PII, as described in US privacy law and information 
            security, is information that can be used on its own or with other information to identify, contact, or locate
             a single person, or to identify an individual in context. Please read our Privacy Policy carefully to get a 
             clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable 
             Information in accordance with our Site.</p>

             <h4>Information we collect</h4>
             <ul>
                <li>When you download and use our Expense Tracker App, we may collect personal information such as your name, email address.</li>
                <li>We may also collect non-personal information such as your device type, operating system, and usage data.</li>
                <li>We use third-party analytics tools to collect information about your use of our app, such as the pages you view and the features you use.</li>
            </ul>
            <h4>How we use your information</h4>
            <ul>
              <li>We use your personal information to provide you with access to our Expense Tracker App and to communicate with you about updates and other important information.</li>
              <li>We use non-personal information to improve our app and to better understand how users interact with it.</li>
              <li>We do not sell or share your personal information with third-party advertisers or marketers.</li>
            </ul>
            <h4>Changes to this Privacy Policy</h4>
            <p>We may update this Privacy Policy from time to time. Any changes to this Privacy Policy will be posted on our website and within our Expense Tracker App. We encourage you to review this Privacy Policy periodically to stay informed about how we are protecting your personal information.
            </p>
            <h4>Data Deletion Information</h4>
            <p> We take the privacy of our users seriously and are committed to being transparent about how we 
            collect, use, and store data. Here is some information about our data deletion policies:</p>
            <p>We collect personal information, such as names and email addresses, to personalize the user 
            experience, communications, provide support on login issue and improve our website.
            Data from Facebook and the data you create while managing monthly finance are permanently deleted when you 
            navigage to Settings and click on <strong>Delete Account</strong> Button. We erase the data from server, which is non-recoverable.</p>
            <h4>Communications from us</h4>
            <p>We may from time to time send you service-related announcements when we consider it
            necessary to do so (such as when we temporarily down the Platform for maintenance, or
            security, privacy, or administrative-related communications). We send these to you via
            email, push notifications and any other communication channel. You may not opt-out of these
            service-related announcements, which are not promotional in nature and used solely to protect
            your account and keep you informed of important changes to the Platform.</p>
            <h4>Contact us</h4>
            <p>If you have any questions about this Privacy Policy or our data protection practices, please contact us at <strong>info@jsonworld.com</strong></p>
            <p>IF YOU DO NOT AGREE WITH THE TERMS OF THIS PRIVACY POLICY, PLEASE
              DO NOT USE THE APP.</p>

          </Grid>
        </Container>
      </Grid>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
